import { useAddressSearchActions } from './useAddressSearchActions';
import { useAddressSearchForm } from './useAddressSearchForm';

export const useAddressSearch = () => {
    const actions = useAddressSearchActions();
    const form = useAddressSearchForm();

    return {
        ...actions,
        form,
    };
};
